/**
 * 水印用本地时间格式化工具模块（基于 dayjs，不使用原生 Date）。
 */
import dayjs, { type Dayjs } from 'dayjs';

/** 可传入 dayjs 的时间入参（不含 Date） */
export type WatermarkTimeInput = string | number | Dayjs;

/**
 * AI.GEN lines=1-1
 * 将时间格式化为水印用本地时间字符串（YYYY-MM-DD HH:mm:ss），含秒。
 *
 * @param source - 可选；不传则表示当前时刻，否则按 dayjs 规则解析
 * @returns 格式化后的时间文本
 */
export function formatWatermarkLocalTime(source?: WatermarkTimeInput): string {
  return dayjs(source).format('YYYY-MM-DD HH:mm:ss');
}
